import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';  // <-- import detector

import mkTranslation from './locales/mk/translation.json';
import enTranslation from './locales/en/translation.json';

i18n
  .use(LanguageDetector)   // <-- add this!
  .use(initReactI18next)
  .init({


    resources: {
      mk: { translation: mkTranslation },
      en: { translation: enTranslation },
    },
    fallbackLng: 'mk',
    lng: localStorage.getItem('i18nextLng') || 'mk', // Force read from localStorage first

    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'htmlTag', 'path', 'subdomain', 'navigator'], // moved navigator last
      caches: ['localStorage'],
    }
  });

export default i18n;
